import {alphas, greysDark} from '../../styles/colorStyles';
import {darkAccentSemanticStyles} from '../semantic/accentSemanticStyles';
import {darkAnnotationSemanticStyles} from '../semantic/annotationSemanticStyles';
import {darkAppFrameSemanticStyles} from '../semantic/appFrameSemanticStyles';
import {darkBackgroundSemanticStyles} from '../semantic/backgroundSemanticStyles';
import {darkBorderSemanticStyles} from '../semantic/borderSemanticStyles';
import {darkCellSemanticStyles} from '../semantic/cellSemanticStyles';
import {darkCommentComposerSemanticStyles} from '../semantic/commentComposerSemanticStyles';
import {darkComposerSemanticStyles} from '../semantic/composerSemanticStyles';
import {darkIconSemanticStyles} from '../semantic/iconSemanticStyles';
import {darkInlineBannerSemanticStyles} from '../semantic/inlineBannerSemanticStyles';
import {darkInputSemanticStyles} from '../semantic/inputSemanticStyles';
import {darkLeftBarSemanticStyles} from '../semantic/leftBarSemanticStyles';
import {darkMessageSemanticStyles} from '../semantic/messageSemanticStyles';
import {darkMetricsSemanticStyles} from '../semantic/metricsSemanticStyles';
import {darkMobileSemanticStyles} from '../semantic/mobileSemanticStyles';
import {sharedSearchBarSemanticStyles} from '../semantic/searchBarSemanticStyles';
import {darkSettingsSemanticStyles} from '../semantic/settingsSemanticStyles';
import {darkSidePanelSemanticStyles} from '../semantic/sidePanelSemanticStyles';
import {darkTabSemanticStyles} from '../semantic/tabSemanticStyles';
import {darkTagSemanticStyles} from '../semantic/tagSemanticStyles';
import {darkTextSemanticStyles} from '../semantic/textSemanticStyles';
import {darkToggleSemanticStyles} from '../semantic/toggleSemanticStyles';
import {darkTooltipSemanticStyles, upsellTooltipSemanticStyles} from '../semantic/tooltipSemanticStyles';
import {sharedTopBarSemanticStyles} from '../semantic/topBarSemanticStyles';
import {
  darkTypographySemanticStyles,
  mobileDarkTypographySemanticStyles,
} from '../semantic/typographySemanticStyles';
import {darkVerticalSwitcherSemanticStyles} from '../semantic/verticalSwitcherSemanticStyles';
import {themeConstants} from '../themeConstants';
import {SemanticStyles} from '../themeTypes';
import {DARK_APP_FOREGROUND_COLOR} from './darkColorHelpers';

export const darkSemanticStyles: SemanticStyles = {
  rounded: true,

  brand: themeConstants.black,

  appBackground: greysDark.white,
  foreground: DARK_APP_FOREGROUND_COLOR,

  invertedIcon: alphas.white50,
  indicatorColor: darkAccentSemanticStyles.red.highlight,

  modalBackdrop: alphas.black60,

  colorScheme: 'dark',
  accent: darkAccentSemanticStyles,

  defaultInboxColor: darkAccentSemanticStyles.grey.highlight,

  windowsButtonHover: alphas.white20,

  scrollbarTrack: alphas.transparent,
  scrollbarThumb: alphas.white30,

  textStyles: darkTextSemanticStyles,
  typography: darkTypographySemanticStyles,
  mobileTypography: mobileDarkTypographySemanticStyles,
  mobile: darkMobileSemanticStyles,
  icon: darkIconSemanticStyles,
  cell: darkCellSemanticStyles,
  topBar: sharedTopBarSemanticStyles,
  sidePanel: darkSidePanelSemanticStyles,
  searchBar: sharedSearchBarSemanticStyles,
  tab: darkTabSemanticStyles,
  tag: darkTagSemanticStyles,
  message: darkMessageSemanticStyles,
  inlineBanner: darkInlineBannerSemanticStyles,
  annotation: darkAnnotationSemanticStyles,
  commentComposer: darkCommentComposerSemanticStyles,
  leftBar: darkLeftBarSemanticStyles,
  settings: darkSettingsSemanticStyles,
  toggle: darkToggleSemanticStyles,
  appFrame: darkAppFrameSemanticStyles,
  tooltip: darkTooltipSemanticStyles,
  upsellTooltip: upsellTooltipSemanticStyles,
  input: darkInputSemanticStyles,
  border: darkBorderSemanticStyles,

  verticalSwitcher: darkVerticalSwitcherSemanticStyles,

  metrics: darkMetricsSemanticStyles,

  background: darkBackgroundSemanticStyles,

  composer: darkComposerSemanticStyles,
};
